import timestampedResources from './naturals.json' with { type: 'json' };
export default timestampedResources;
